module.exports = __webpack_public_path__ + "img/base.5727d2d3.png";